import { formatBallotDataFormValues, formatBallotDataToService } from "./ballot";
import { formatOtherDataFormValues, formatOtherDataToService } from "./other-data";
import { formatPersonalDataFormValues, formatPersonalDataToService } from "./personal";
import { formatProfessionalDataFormValues, formatProfessionalDataToService } from "./professional-data";
import { formatQualificationBaseDataFormValues, formatQualificationBaseDataToService } from "./qualification-base-data";
import { formatCvDataToService, formatQualificationCvDataFormValues } from "./qualification-cv-data";
import { formatQualificationOtherDataFormValues, formatQualificationOtherDataToService } from "./qualification-other-data";
import { formatQualificationOtherPostGradDataFormValues, formatQualificationOtherPostGradDataToService } from "./qualification-other-post-grad-data";
import { formatQualificationPhysioPostGradDataToService, formatQualificationPhysioPostGradDataFormValues } from "./qualification-physio-post-grad-data";

export const formatAssociateDataFormValues = (associate) => {
    associate = formatPersonalDataFormValues(associate);
    associate = formatQualificationBaseDataFormValues(associate);
    associate = formatQualificationPhysioPostGradDataFormValues(associate);
    associate = formatQualificationOtherPostGradDataFormValues(associate);
    associate = formatOtherDataFormValues(associate);
    associate = formatProfessionalDataFormValues(associate);
    associate = formatQualificationOtherDataFormValues(associate);
    associate = formatBallotDataFormValues(associate);
    associate = formatQualificationCvDataFormValues(associate);
        
    return associate;
}
export const formatAssociateDataToService = (associate) => { 

    associate = formatPersonalDataToService(associate);
    associate = formatQualificationBaseDataToService(associate);
    associate = formatQualificationPhysioPostGradDataToService(associate);
    associate = formatQualificationOtherPostGradDataToService(associate);
    associate = formatOtherDataToService(associate);
    associate = formatProfessionalDataToService(associate);
    associate = formatQualificationOtherDataToService(associate);
    associate = formatBallotDataToService(associate);
    associate = formatCvDataToService(associate);

    
    
    
    return associate;
}